const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
const arabicDigits = '٠١٢٣٤٥٦٧٨٩';

export function normalizePersianCharacters(value: string): string {
  return value
    .normalize('NFKC')
    .replace(/[يى]/gu, 'ی')
    .replace(/ك/gu, 'ک')
    .replace(/ۀ/gu, 'ه')
    .replace(/[أإٱ]/gu, 'ا')
    .replace(/ؤ/gu, 'و')
    .replace(/[ً-ٰٟ]/gu, '')
    .replace(/[​‌‍⁠]/gu, ' ')
    .replace(/[۰-۹]/gu, (digit) => String(persianDigits.indexOf(digit)))
    .replace(/[٠-٩]/gu, (digit) => String(arabicDigits.indexOf(digit)))
    .replace(/(?:^|\s)رو(?=$|\s)/gu, (match) => `${match.startsWith(' ') ? ' ' : ''}را`)
    .replace(/(?:^|\s)واسه(?=$|\s)/gu, (match) => `${match.startsWith(' ') ? ' ' : ''}برای`)
    .replace(/(?:^|\s)یه(?=$|\s)/gu, (match) => `${match.startsWith(' ') ? ' ' : ''}یک`)
    .replace(/تأمين/gu, 'تامین');
}
